module.exports = __webpack_public_path__ + "assets/img/role-active-2.7debed2a.png";